const GUID_REGEX = /(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/i;
export const extractGuidFromString = (value: string) => {
  return value.split('/').filter((part) => GUID_REGEX.test(part));
};
